export const notesConnectionFiltersEnum = {
  RANGE_PERIOD: 'range-period',
  STATUS: 'status',
};

